<template>
    <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38.1617 38.1641L14.1055 14.1055M14.108 38.1641L38.1641 14.1055" stroke="currentColor" stroke-width="4"
            stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>